import Vue from 'vue'
import Vuex from 'vuex'
import qs from 'qs'
import cookie from 'vue-cookie'
var querystring = require('querystring');
const tokenAuthCrm = cookie.get('crm_auth_token');
const tokenAuthCrm_testCrm = cookie.get('crm_auth_token_test_crm');
// import lodash from 'lodash'
// import { stat } from 'fs';
// import firebase from 'firebase'

Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        //Baner System
        gCap_siteKey: '6LfWSsspAAAAAERKIehZNIXrGgHm4LDuPRTwiypi',
        banerSystem: null,
        // baner top
        homeVerticalTopBaner: null,
        salesVerticalTopBaner: null,
        // baner bottom
        homeVerticalBottomBaner: null,
        salesVerticalBottomBaner: null,
        salesItemBaner: true, // кастомная переменная для релоуда компонента банера в карточках комлпексов
        //server vars
        pageSetup: null,
        indexPage: null,
        aboutPageArr: null,
        qualityPage: null,
        actionPage: null,
        newsPage: null,
        salesPage: null,
        flatsPage: null,
        salesMapPage: null,
        howToBy: null,
        howToTake: null,
        bazisFinance: null,
        onlinePage: null,
        ENPFpage: null,
        privacyPolicyPage: null,

        onlineBoockingPage: null,
        newOwnersPage: null,
        commerceSalesPage: null,
        commerceSalesItems: null,
        seismicSafetyPage: null,
        seismicSafetyNewsItems: null,
        seismicSafetyVideoItems: null,
        awardsPage: null,
        answersPage: null,
        //Favorite Page
        favoritePage: null,
        favoriteCount: 0,
        //Compare Page
        comparePage: null,
        compareCount: 0,
        // Hypothec 
        hypothecPage: null,
        hypothecCalculatorPage: null,
        //Contacts page
        contactsPage: null,
        contactsCardAnimate: true,
        contactsMapCoords: [],
        pinCoords: {
            lat: null,
            lng: null,
        },
        // our projects
        projectsPage: null,
        projectBuiltItems: null,
        // BAZIS-CLUB
        bazisClub: null,
        bazisClubItems: null,
        bazisClubCategoryCounter: null,
        //sales vars
        projectItems: null,
        projectItemsDefault: null,
        projectItemsDefaultFilterItems: null,
        projectItemsFilter: null,
        projectItemsMap: [],
        projectItemsFilterCity: null,
        cardAnimate: true,
        mapCoords: [],
        MapItemsTheme: 'default',
        MapMarkersPos: [],
        salesCardPage: null,
        salesCardPageID: 'default',

        salesCardContent: null,
        salesCardContentFlats: [],
        salesCardContentFlatsDefault: [],
        salesFlatsLandCardAnimateCards: true,
        salesLandModalData: null,

        saleCardAnimate: true,

        //actions vars
        actionsItems: null,
        actionsItemsDefault: [],
        actionsItemsFilter: [],
        actionCardAnimate: true,
        //news vars
        newsItems: null,
        newsItemsDefault: [],
        newsItemsFilter: [],
        newsCardAnimate: true,
        newsPageCount: 1,
        //video vars
        videoPage: null,
        videoItems: [],
        videoItemsDefault: [],
        videoItemsFilter: [],
        videoCardAnimate: true,
        videPageCount: 1,
        videoHidePaginBtn: false,

        videoItemsSafety: [],
        // project vars
        currentCity: null,
        currentCityArr: null,
        breadCrumbInit: null,
        customCrumbGlobalVar: null,
        pageName: null,
        SETpageID: null,
        hidePaginBtn: false,
        forms: null,
        // MOBILE VARS
        isOpenPhonesCityMobile: false,
        isOpenSendwich: false,
        isOpenFormConsult: false,
        isOpenFormBazisClub: false,
        isOpenFormSignUpProject: false,
        isOpenSalesModal: false,
        isOpenFormMailFlatsCrm: false,
        isOpenFormMailFlatsCrmMobile: false,
        isOpenFormLandModal: false,
        isOpenMapFlatsCrmCard: false,
        isopenSortFlatsTopBar: false,
        flatsLandGridView: true,
        formBazisClubView: false,
        formConsultData: null,
        coockieBanerTopVisible: false,
        titleSite: 'Жилые комплексы от BAZIS-A. ENJOY LIFE!',
        isMobileChecker: false,
        salesFilterParams: {
            cityActive: 'all',
            saleStat: 0,
            initFilter: false,
        },
        // STATE ДЛЯ ОБЪЕКТОВ СВЗЯЬ МЕЖДУ ПРОЕКТОМ И СРМ СИСТЕМОЙ
        crmProjects: null,
        complexesItems: null,
        filterDynamicParams: { // динамические параметры фильтра города и объекта
            // Для фильтра по городам
            cityActive: 'all',
            resetCity: true,
            cityCodesRadioChecked: [],
            cityFilterDefault: null,
            // Для фильтра по комплексам
            descSelectComplexes: 'all',
            resetComplex: true,
            complexesCodeRadioChecked: [],
            selectedComplexes: [],
            projectsFilterDefault: null,
            projectsFilterStart: null,
            projectsFilterComplexesDefault: [],
            // Параметры сортировки
            shortingParamsDefault: {
                param:  'Комнатности',
                rule: 'Возрастанию',
            },
        },
        filterMinMaxParams: {
            init: false,
            price: {
                min: [],
                max: [],
            },
            size: {
                min: [],
                max: [],
            },
            floor: {
                min: [],
                max: [],
            },
        },
        // STATE ДЛЯ ФИЛЬТРА ПО КВАРТИРАМ
        filterData: { // переменные для хранения данных фильтрации
            cityCodes: [],
            complexCodes: [],
            roomQuantities: [],
            areaFrom: null,
            areaTo: null,
            floorRangeStart: null,
            floorRangeEnd: null,
            meterPriceFrom: null,
            meterPriceTo: null,
            linesOnPage: 30,
            pageNumber: 1,
            sortedByField: 'ROOM',
            sortedByDirection: 'ASCENDING',
        },
        flatsPagination: {
            allApartments: 0,
            remainingApartments: 0,
            remainingPages: 0,
        },
        flatsItems: null, // массив квартир из срм
        flatsEmptyMsg: false, // параметр видимости сообщения о пустом поиске квартир согласно параметрам
        pagin_PageNumber: 1, // текущее число страницы пагинации квартир
        hidePaginBtn: false, // параметр скрытия кнопки пагинации
        visibleFilterMobile: false, // параметр включения мобильного фильтра
        FilterResetTrigger: false, // параметр сброса даных фильтра
        visibleCardImgWindow: false,
        cardImgWindowData: null,

        urlRocketLC: 'https://lk01.bazis.kz',
        // https://testlk01.bazis.kz
        // https://lk01.bazis.kz
        // https://bazis-a.rocketfirm.digital
        urlCRMuco: 'https://bazis-online.kz/crmc',
        ucoCRM_oauth_token: null,
        ucoCRM_oauth_token_testcrm: null,
        // https://bazis-online.kz/crmc
        // https://demo.uco.kz/crmc

    },
    getters: {
        loadGcap_sitekey: state => state.gCap_siteKey,
        loadUrlRocketLC: state => state.urlRocketLC,
        loadUrlCRMuco: state => state.urlCRMuco,
        loadUcoCRM_auth_token: state => state.ucoCRM_oauth_token,
        loadUcoCRM_auth_token_testcrm: state => state.ucoCRM_oauth_token_testcrm,
        //Baner System
        loadBanerSystem: state => state.banerSystem,
        // Vertical top baners
        loadHomeTopBaner: state => state.homeVerticalTopBaner,
        loadSalesTopBaner: state => state.salesVerticalTopBaner,
        loadSalesItemBaner: state => state.salesItemBaner,
        // loadShuffleTopVerticalBaner: state => state.shuffleTopVerticalBaner,
        // loadShuffleBottomVerticalBnaer: state => state.shuffleBottomVerticalBaner,
        // Pages
        loadPageSetUp: state => state.pageSetup,
        loadIndexPage: state => state.indexPage,
        loadAboutPage: state => state.aboutPageArr,
        loadQualityPage: state => state.qualityPage,
        loadProjectsPage: state => state.projectsPage,
        loadProjectsBuiltItems: state => state.projectBuiltItems,
        loadActionPage: state => state.actionPage,
        loadNewsPage: state => state.newsPage,
        loadSalesPage: state => state.salesPage,
        loadFlatsPage: state => state.flatsPage,
        loadSalesMapPage: state => state.salesMapPage,
        loadHowToBy: state => state.howToBy,
        loadHowToTake: state => state.howToTake,
        loadBazisFinancePage: state => state.bazisFinance,
        loadOnlinePage: state => state.onlinePage,
        loadENPFpage: state => state.ENPFpage,
        loadPrivacyPage: state => state.privacyPolicyPage,

        loadOnlineBoockingPage: state => state.onlineBoockingPage,
        loadNewOwnersPage: state => state.newOwnersPage,
        loadCommerceSalesPage: state => state.commerceSalesPage,
        loadCommerceSalesItems: state => state.commerceSalesItems,
        loadSeismicSafetyPage: state => state.seismicSafetyPage,
        loadSeismicSafetyNewsItems: state => state.seismicSafetyNewsItems,
        loadSeismicSafetyVideoItems: state => state.seismicSafetyVideoItems,
        loadAwardsPage: state => state.awardsPage,
        loadAnswersPage: state => state.answersPage,
        // Favorite page
        loadFavoritePage: state => state.favoritePage,
        // Compare page
        loadComparePage: state => state.comparePage,
        // Hypothec PAGE
        loadHypothecPage: state => state.hypothecPage,
        loadHypothecCalculatorPage: state => state.hypothecCalculatorPage,
        //CONTACTS PAGE
        loadContactsPage: state => state.contactsPage,
        loadContactsCardAnimate: state => state.contactsCardAnimate,
        loadContactsMapCoords: state => state.contactsMapCoords,
        loadPinCoords: state => state.pinCoords,
        // Bazis Club
        loadBazisClub: state => state.bazisClub,
        loadBazisClubItems: state => state.bazisClubItems,
        loadBazisCategoryCounter: state => state.bazisClubCategoryCounter,
        //sales getters
        loadProjectItems: state => state.projectItems,
        loadProjectItemsDefault: state => state.projectItemsDefault,
        loadProjectItemsDefaultFilterItems: state => state.projectItemsDefaultFilterItems,
        loadProjectItemsFilter: state => state.projectItemsFilter,
        loadProjectItemsMap: state => state.projectItemsMap,
        loadProjectItemsFilterCity: state => state.projectItemsFilterCity,
        loadCardAnimateStatus: state => state.cardAnimate,
        loadMapCoords: state => state.mapCoords,
        loadMapItemsTheme: state => state.MapItemsTheme,
        loadMapMarkersPos: state => state.MapMarkersPos,
        loadSalesCardPage: state => state.salesCardPage,
        loadSalesCardPageID: state => state.salesCardPageID,

        loadSalesCardContent: state => state.salesCardContent,
        loadSalesCardFlats: state => state.salesCardContentFlats,
        loadSalesCardFlatsDefault: state => state.salesCardContentFlatsDefault,
        loadSalesLandCardAnimate: state => state.salesFlatsLandCardAnimateCards,
        loadSalesLandModalDataArr: state => state.salesLandModalData,

        // loadSaleCardAnimate: state => state.saleCardAnimate,
        //actions getters
        loadActionsItems: state => state.actionsItems,
        loadActionsItemsDefault: state => state.actionsItemsDefault,
        loadActionsItemsFilter: state => state.actionsItemsFilter,
        loadActionCardAnimateStatus: state => state.actionCardAnimate,
        //news getters
        loadNewsItems: state => state.newsItems,
        loadNewsItemsDefault: state => state.newsItemsDefault,
        loadNewsItemsFilter: state => state.newsItemsFilter,
        loadNewsCardAnimateStatus: state => state.newsCardAnimate,
        loadNewsPageCount: state => state.newsPageCount,
        // video getters
        loadVideoPage: state => state.videoPage,
        loadVideoItems: state => state.videoItems,
        loadVideoItemsDefault: state => state.videoItemsDefault,
        loadVideoItemsFilter: state => state.videoItemsFilter,
        loadVideoCardAnimateStatus: state => state.videoCardAnimate,
        loadVideoPageCount: state => state.videoPageCount,
        loadHidePaginBtnVideo: state => state.videoHidePaginBtn,

        loadVideoItemsSafety: state => state.videoItemsSafety,
        // custom getters
        loadCurrentCity: state => state.currentCity,
        loadCurrentCityArr: state => state.currentCityArr,
        loadBreadCrumbInit: state => state.breadCrumbInit,
        loadCustomCrumbGlobal: state => state.customCrumbGlobalVar,
        loadPageName: state => state.pageName,
        loadFavoriteCount: state => state.favoriteCount,
        loadHidePaginBtn: state => state.hidePaginBtn,
        loadForms: state => state.forms,
        // Mobile getters
        loadPhonesCityOpen: state => state.isOpenPhonesCityMobile,
        loadOpenSendwich: state => state.isOpenSendwich,
        loadOpenFormConsult: state => state.isOpenFormConsult,
        loadOpenFormSignUpProject: state => state.isOpenFormSignUpProject,
        loadOpenFormBazis: state => state.isOpenFormBazisClub,
        loadOpenFormMailFlatsCRM: state => state.isOpenFormMailFlatsCrm,
        loadOpenFormMailFlatsCRM_mobile: state => state.isOpenFormMailFlatsCrmMobile,
        loadOpenMapFlatsCrmCard: state => state.isOpenMapFlatsCrmCard,
        loadOpenSortFlatsTopBar: state => state.isopenSortFlatsTopBar,
        loadIsOpenFormLandModal: state => state.isOpenFormLandModal,
        loadSalesModalAction: state => state.isOpenSalesModal,
        loadFormConsultData: state => state.formConsultData,
        loadFormBazisClubView: state => state.formBazisClubView,
        loadSiteTitle: state => state.titleSite,
        loadCockieBanerTopVisible: state => state.coockieBanerTopVisible,
        loadIsMobileChecker: state => state.isMobileChecker,
        
        loadSalesFilterParams: state => state.salesFilterParams,
        // GETTERS ДЛЯ ОБЪЕКТОВ СВЗЯЬ МЕЖДУ ПРОЕКТОМ И СРМ СИСТЕМОЙ
        loadCrmProjects: state => state.crmProjects,
        loadComplexesItems: state => state.complexesItems, // для фильтра по квартирам
        // GETTERS ДЛЯ ФИЛЬТРА ПО КВАРТИРАМ
        // GETTERS FOR CRM FLATS
        loadFilterData: state => state.filterData, // параметры филтра
        loadFilterDynamicParam: state => state.filterDynamicParams, // Значения фильтров для динамической загрузки данных при переходах между страницами
        loadFilterMinMaxParams: state => state.filterMinMaxParams, // минимальные и максимальные значения для всех фильтров бегунков
        loadFlatsPagination: state => state.flatsPagination, // параметры остаточных значений(счетчиков) пагинации
        loadFlatsItems: state => state.flatsItems, // массив квартир из срм
        loadFlatsEmptyMsg: state => state.flatsEmptyMsg, // параметр видимости сообщения о пустом поиске квартир согласно параметрам
        loadLandFlatsGridView: state => state.flatsLandGridView, // вид стилистики карточек квартир

        loadPaginPageNumber: state => state.pagin_PageNumber,
        loadHidePaginBtn: state => state.hidePaginBtn,
        loadVisibleFilterMobile: state => state.visibleFilterMobile,
        loadResetTriggerMove: state => state.FilterResetTrigger,
        loadVisibleCardImgWindow: state => state.visibleCardImgWindow,
        loadCardImgWindowData: state => state.cardImgWindowData,
    },
    actions: {
        getFullSetUpProject({commit}) {
            if (this.state.pageSetup == null || this.state.banerSystem == null || this.state.forms == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'settings').then(async (response) => {
                        // console.log(response.data[2].acf, 'full setup');
                        // commit('setBanerSystem', response.data[0].acf);
                        commit('PageSetUp', response.data[1].acf);
                        commit('formsData', response.data[0].acf);
                        resolve('complete');
                    });
                });
            }
        },
        getIndexPageData({commit}) {
            if (this.state.indexPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1643').then(async (response) => {
                        // console.log(response.data.acf, 'index page');
                        commit('indexPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getAboutPageData({commit}) {
            if (this.state.aboutPageArr == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1691').then(async (response) => {
                        // console.log(response.data.acf, 'about page');
                        commit('aboutPageSet', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getQualityPageData({commit}) {
            if (this.state.qualityPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1695').then(async (response) => {
                        // console.log(response.data.acf, 'quality page');
                        commit('qualityPageSet', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getOnlineBoockingPageData({commit}) {
            if (this.state.onlineBoockingPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1681').then(async (response) => {
                        // console.log(response.data.acf, 'ONLINE BOOCKING PAGE');
                        commit('OnlineBoockingPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getNewsOwnersPageData({commit}) {
            if (this.state.newOwnersPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1675').then(async (response) => {
                        // console.log(response.data.acf, 'NEW OWNERS PAGE');
                        commit('NewOwnersPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getCommerceSalesPageData({commit}) {
            if (this.state.commerceSalesPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1659').then(async (response) => {
                        // console.log(response.data.acf, 'COMMERCE SALES');
                        commit('CommerceSalesPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getCommerceItemsByIDs({commit}, payload) {
            if (this.state.commerceSalesItems == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/commerce?include=' + payload).then(async (response) => {
                        // console.log(response, 'commerce sales ITEMs');
                        commit('commerceSalesItems', response.data);
                        resolve('complete');
                    });
                });
            }
        },
        getSeismicSafetyPageData({commit}) {
            if (this.state.seismicSafetyPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1697').then(async (response) => {
                        // console.log(response.data.acf, 'seismic safety page');
                        commit('SeismicSafetyPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getSeismicSafetyNewsByIDs({commit}, payload) {
            if (this.state.seismicSafetyNewsItems == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/news?include=' + payload).then(async (response) => {
                        // console.log(response, 'safety news ITEMs');
                        commit('sesmicSafetyNewsItems', response.data);
                        resolve('complete');
                    });
                });
            }
        },
        getSeismicSafetyVideoByIDs({commit}, payload) {
            if (this.state.seismicSafetyVideoItems == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/video_safety?include=' + payload).then(async (response) => {
                        // console.log(response, 'safety video ITEMs');
                        commit('sesmicSafetyVideoItems', response.data);
                        resolve('complete');
                    });
                });
            }
        },
        getAwardsPageData({commit}) {
            if (this.state.awardsPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1693').then(async (response) => {
                        // console.log(response.data.acf, 'awards safety page');
                        commit('AwardsPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getAnswersPageData({commit}) {
            if (this.state.answersPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1683').then(async (response) => {
                        // console.log(response.data.acf, 'answers page');
                        commit('AnswersPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getActionPageData({commit}) {
            if (this.state.actionPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1649').then(async (response) => {
                        // console.log(response.data.acf);
                        commit('actionPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getENPFPage({commit}) {
            if (this.state.onlinePage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1679').then(async (response) => {
                        // console.log(response.data.acf, 'ENPF PAGE');
                        commit('enpfPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getOnlinePageData({commit}) {
            if (this.state.onlinePage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1681').then(async (response) => {
                        // console.log(response.data.acf, 'ONLINE PAGE');
                        commit('onlinePage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getPrivacyPage({commit}) {
            if (this.state.privacyPolicyPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/3428').then(async (response) => {
                        // console.log(response.data.acf, 'HOW TO BY');
                        commit('PrivacyPolicy', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getNewsPageData({commit}) {
            if (this.state.newsPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1645').then(async (response) => {
                        // console.log(response.data.acf);
                        commit('newsPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getHowToByPage({commit}) {
            if (this.state.howToBy == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1667').then(async (response) => {
                        // console.log(response.data.acf, 'HOW TO BY');
                        commit('HowToBy', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        // getHowToTakePage({commit}) {
        //     if (this.state.howToTake == null) {
        //         return new Promise((resolve, reject) => {
        //             axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1087').then(async (response) => {
        //                 // console.log(response.data.acf);
        //                 commit('HowToTake', response.data.acf);
        //                 resolve('complete');
        //             });
        //         });
        //     }
        // },
        // Favorite Page
        getFavoritePage({commit}) {
            if (this.state.favoritePage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1685').then(async (response) => {
                        // console.log(response.data.acf, 'FAVORITE PAGES');
                        commit('FavoritePage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        // Compare Page
        getComparePage({commit}) {
            if (this.state.comparePage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1687').then(async (response) => {
                        // console.log(response.data.acf, 'compare PAGE');
                        commit('ComparePageSet', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        // Hypothec Page
        getHypothecPage({commit}) {
            if (this.state.hypothecPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1671').then(async (response) => {
                        // console.log(response.data.acf);
                        commit('HypothecPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getHypothecCalculatorPage({commit}) {
            if (this.state.hypothecCalculatorPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1673').then(async (response) => {
                        // console.log(response.data.acf);
                        commit('HypothecCalculatorPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getBazisFinancePage({commit}) {
            if (this.state.bazisFinance == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1677').then(async (response) => {
                        // console.log(response.data.acf, 'BAZIS FINANCE');
                        commit('bazisFinancePage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        //BAZIS CLUB ACTIONS
        getBazisClubPageData({commit}) {
            if (this.state.bazisClub == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1669').then(async (response) => {
                        // console.log(response.data.acf, 'PAGE BAZIS CLUB');
                        commit('bazisClubPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getBazisClubItems({commit}) {
            if (this.state.bazisClubItems == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'bazis_club/?per_page=1000').then(async (response) => {
                        // console.log(response.data, 'ITEMS');
                        commit('bazisClubItems', response.data);
                        resolve('complete');
                    });
                });
            }
        },
        getBazisClubCategoryCounter({commit}) {
            if (this.state.bazisClubCategoryCounter == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/bazis_club_category/?per_page=100').then(async (response) => {
                        commit('bazisClubCategoryCounter', response.data);
                        resolve('complete');
                    });
                });
            }
        },
        // END BAZIS CLUB
        getSalesPageData({commit}) {
            if (this.state.salesPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1651').then(async (response) => {
                        // console.log(response.data.acf);
                        commit('salesPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getFlatsPageData({commit}) {
            if (this.state.flatsPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1661').then(async (response) => {
                        // console.log(response.data.acf);
                        commit('flatsPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getSalesMapPageData({commit}) {
            if (this.state.salesMapPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1655').then(async (response) => {
                        // console.log(response.data.acf);
                        commit('salesMapPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        // SALES CARD PROMO/LAND
        getSalesCardPageData({commit}) {
            if (this.state.salesCardPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1657').then(async (response) => {
                        // console.log(response.data.acf, 'sale CARD PAGE DATA DEFAULT');
                        commit('salesCardPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        // getSalesCardContent({commit}, payload) {
        //     return new Promise((resolve, reject) => {
        //         axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/projects?slug=' + payload).then(async (response) => {
        //             // console.log(response.data, payload, 'TEST')
        //             commit('salesCardContent', response.data[0].acf);
        //             resolve('complete');
        //         });
        //     });
        // },
        // END SALES CARD PROMO/LAND
        getContactsPageData({commit}) {
            if (this.state.contactsPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1663').then(async (response) => {
                        // console.log(response.data.acf, 'CONTACTS');
                        commit('contactsPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        // PAGE SALES CARDS / FLATS
        getProjectsItems({commit, dispatch, state}) { // test auth
            // console.log('stataararar', this.state.projectItems.length)
            if (this.state.projectItems == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'sales/?per_page=40').then(async (response) => {
                        // console.log(window.url + window.GlobalLang + window.JsonUrl + 'sales/?per_page=40')
                        // console.log(response.data, 'array houses')
                        var dataComplexes = []; // Для фильтра по жк (Список исходных кодов жк для СРМ)
                        var dataResp = {complexCodes: []}; // список жк доступных к запросу из СРМ
                        for(var i=0; i < response.data.length; i++) {
                            // console.log(response.data[i].acf.project_name.slug)
                            if (response.data[i].acf.crm_code != null && response.data[i].acf.crm_code != '')  {
                                dataResp.complexCodes.push(response.data[i].acf.crm_code); // Сбор параметров для запроса ЖК из СРМ
                                // Для фильтра по жк (Сбор исходных кодов жк для СРМ)
                                // console.log(response.data[i].acf.crm_code, response.data[i].acf.project_name.name)
                                dataComplexes.push({
                                    'code': response.data[i].acf.crm_code,
                                    'name' : response.data[i].acf.project_name.name,
                                });
                            }
                        }
                        // console.log(dataResp, dataComplexes)
                        commit('projectItems', response.data); // коммит всех объектов
                        commit('filterCompelxes', dataComplexes); // коммит для фильтра по жк (квартиры)

                        axios.post(window.CRMurl + '/rest/prices/getComplexes', dataResp, { // Запрос Данных об объектах из СРМ test auth
                            headers: { 
                                'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                            } 
                        }).then((response) => {
                            // console.log(response, response.data.data, 'GetComplexecomplexes after AUTH');
                            commit('crmItemsSet', response.data.data);
                        }).catch((error) => {
                            console.log('error getComplexes', error.response.data, error.response.status);
                            // if (error.response.data.error == 'invalid_token') {
                            //     dispatch('getCrmAuthChecker', {'error' : 'invalid_token'});
                            // }
                        });
                        resolve('complete');
                    });
                });
            }
        },
        // getFilterProjectItems({commit, dispatch}) { // test auth
        //     // console.log('stataararar', this.state.projectItems.length)
        //     if (this.state.projectItemsDefaultFilterItems == null) {
        //         return new Promise((resolve, reject) => {
        //             axios.get(window.url + window.GlobalLang + window.JsonUrl + 'sales-filters/?per_page=30').then(async (response) => {
        //                 // console.log(response.data, 'Filter sales items from cms houses')
        //                 commit('FilterSalesProjectItems', response.data); // коммит всех объектов
        //             });
        //         });
        //     }
        // },
        // ACTIONS CARDS
        getActionsItems({commit}) {
            if (this.state.actionsItems == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'actions/?per_page=100').then(async (response) => {
                        // console.log(response, 'asdasdsadasd')
                        commit('actionsItems', response.data);
                        resolve('complete');
                    });
                });
            }
        },
        //NEWS CARDS
        getNewsItems({commit}) {
            if (this.state.newsItems == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/news/?start_date=2020-01-01&per_page=8').then(async (response) => {
                        // console.log(response, 'news')
                        commit('newsItems', response.data);
                        commit('newsCountOfPages', parseFloat(response.headers['x-wp-totalpages']))
                        resolve('complete');
                        // console.log(response);
                    });
                });
            }
        },
        getVideoPage({commit}) {
            if (this.state.videoPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1647').then(async (response) => {
                        // console.log(response.data.acf, 'SETUP')
                        commit('videoPage', response.data.acf)
                        resolve('complete');
                    });
                });
            }
        },
        getVideoItems({commit}) {
            if (this.state.videoItems.length == 0) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/video/?start_date=2020-01-01&per_page=8').then(async (response) => {
                        // console.log(response.data, 'VIDEO')
                        commit('videoItems', response.data);
                        commit('videoPageCount', parseFloat(response.headers['x-wp-totalpages']))
                        resolve('complete');
                        // console.log(response);
                    });
                });
            }
        },
        getVideoItemsSafety({commit}) {
            if (this.state.videoItemsSafety.length == 0) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/video_safety/?start_date=2020-01-01&per_page=100').then(async (response) => {
                        // console.log(response.data, 'VIDEO_safety')
                        commit('videoItemsSafety', response.data);
                        resolve('complete');
                        // console.log(response);
                    });
                });
            }
        },
        getProjectsPage({commit}) {
            if (this.state.projectsPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1689').then(async (response) => {
                        // console.log(response.data.acf, 'projects page')
                        commit('projectsPageSet', response.data.acf)
                        resolve('complete');
                    });
                });
            }
        },
        getProjectBuiltObjects({commit}) {
            if (this.state.projectBuiltItems == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + 'wp-json/wp/v2/' + 'projects_complete'+ '?per_page=65').then(async (response) => {
                        // console.log(response);
                        commit('projectsBuiltOjects', response.data);
                        resolve('complete');
                    });
                    // axios.get('https://bazis.kz/cms/' + window.GlobalLang + 'wp-json/wp/v2/' + 'built'+ '?project_type=64&per_page=65').then(async (response) => {
                    //     console.log(response);
                    //     commit('projectsBuiltOjects', response.data);
                    //     resolve('complete');
                    // });
                });
            }
        },
        // FLATS FROM CRM
        //CRM REST APU OAUTH 2.0 
        getFlatsItems({commit, dispatch, state}, payload) { // FLATS DEFAULT LOAD test auth
            if (this.state.flatsItems == null) {
                return new Promise((resolve, reject) => {
                    axios.post(window.CRMurl + '/rest/prices/getApartments', payload, {
                        headers: { 
                            'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                        } 
                    }).then((response) => {
                        // console.log(response, response.data.data, 'apartments after AUTH');
                        commit('flatsItemsArr', response.data.data);
                        resolve('complete FLATS');
                    }).catch((error) => {
                        console.log('error getApartments default', error.response.data, error.response.status);
                        // if (error.response.data.error == 'invalid_token') {
                        //     dispatch('getCrmAuthChecker', {'error' : 'invalid_token'});
                        // }
                    });
                });
            }
        },
        getFlatsByFilter({commit, dispatch, state}, payload) { // FLATS LOAD BY FILTER test auth
            axios.post(window.CRMurl + '/rest/prices/getApartments', payload, {
                headers: { 
                    'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                } 
            }).then((response) => {
                // console.log(response, response.data.data, 'apartments after AUTH FILTER');
                commit('flatsItemsArr', response.data.data);
            }).catch((error) => {
                console.log('error getApartments filter', error.response.data, error.response.status);
                // if (error.response.data.error == 'invalid_token') {
                //     dispatch('getCrmAuthChecker', {'error' : 'invalid_token'});
                // }
            });
        },
        getFlatsByPagination({commit, dispatch, state}, payload) { // FLATS LOAD BY pagination with filter and pagePaginNumber params test auth
            axios.post(window.CRMurl + '/rest/prices/getApartments', payload, {
                headers: { 
                    'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                } 
            }).then((response) => {
                // console.log(response, response.data.data, 'Квартиры после пагинации AUTH');
                commit('flatsItemsArrPagination', response.data.data);
            }).catch((error) => {
                console.log('error getApartments pagination', error.response.data, error.response.status);
                // if (error.response.data.error == 'invalid_token') {
                //     dispatch('getCrmAuthChecker', {'error' : 'invalid_token'});
                // }
            });
        },
        getFlatsPagintationCounters({commit, dispatch, state}, payload) { // Счетчики квартир (остаток вывода и т д) test auth
            axios.post(window.CRMurl + '/rest/prices/getApartmentsCount', payload, {
                headers: { 
                    'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                } 
            }).then((response) => {
                // console.log(response, response.data.data, 'Счетчик квартир AUTH');
                commit('flatsPaginationCountersSet', response.data.data);
            }).catch((error) => {
                console.log('error getApartments pagination Counter', error.response.data, error.response.status);
                // if (error.response.data.error == 'invalid_token') {
                //     dispatch('getCrmAuthChecker', {'error' : 'invalid_token'});
                // }
            });
        },
        getCrmAuthChecker({commit, dispatch}, payload) { // Проверка 401 ошибки когда токен истек (на случай обновления сервера СРМ)
            // console.log(tokenAuthCrm, payload)
            if (payload != undefined && payload.error == 'invalid_token') {
                dispatch('getCrmAuthToken', 'after_error_token_invalid');
                dispatch('getCrmAuthToken_TESTCRM', 'after_error_token_invalid');
                
            } else if (tokenAuthCrm == null || tokenAuthCrm == undefined && tokenAuthCrm_testCrm == null || tokenAuthCrm_testCrm == undefined) {
                dispatch('getCrmAuthToken');
                dispatch('getCrmAuthToken_TESTCRM');
            }
        },
        getCrmAuthToken({commit, dispatch}, payload) { // Получение Токена из СРМ системы для oauth 2.0 в необходимых для авторизации запросов
            return new Promise((resolve, reject) => {
                axios.post('https://admin.sales.bazis.kz/server/new-auth.php', querystring.stringify({'secret_key' : '0L3QtSDRgdGD0LnRgtC1INGB0LLQvtC5INC90L7RgQ=='})).then((response) => {
                    if (response) {
                        var tokenParse = JSON.parse(response.data.token);
                        var token = tokenParse.access_token;
                        commit('setOauthToken_from_server', token);
                        resolve(true);
                        // console.log(token,'- token');
                    } else {
                        resolve(false);
                    }
                    // cookie.set('crm_auth_token', response.data.access_token, { expires: response.data.expires_in + 's' });
                }).catch((error) => {
                    console.log('error ' + error, 'erorr Get Token');
                    resolve(false);
                });
            });
        },
        getCrmAuthToken_TESTCRM({commit, dispatch}, payload) { // Получение Токена из Тестовой СРМ системы для oauth 2.0 в необходимых для авторизации запросов TEST CRM
            return new Promise((resolve, reject) => {
                axios.post('https://admin.sales.bazis.kz/server/new-auth-testcrm.php', querystring.stringify({'secret_key' : '0L3QtSDRgdGD0LnRgtC1INGB0LLQvtC5INC90L7RgQ=='})).then((response) => {
                    if (response) {
                        var tokenParse = JSON.parse(response.data.token);
                        var token = tokenParse.access_token;
                        commit('setOauthToken_testcrm_from_server', token);
                        resolve(true);
                        console.log(token,'- token');
                    } else {
                        resolve(false);
                    }
                    // cookie.set('crm_auth_token', response.data.access_token, { expires: response.data.expires_in + 's' });
                }).catch((error) => {
                    console.log('error ' + error, 'erorr Get Token TEST CRM');
                    resolve(false);
                });
            });
        },
        sendLead_toCRM({commit, dispatch, state}, payload) {
            axios.post(window.CRMurl + '/rest/leads/lead', payload, {
                headers: { 
                    'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                } 
            }).then((response) => {
                console.log(response, 'Отправка лида завершена успешно');
                // commit('flatsPaginationCountersSet', response.data.data);
            }).catch((error) => {
                console.log('Ошибка отправки Лида');
                console.log(error);
                console.log(error.response.data);
                console.log(error.response.status);
                // if (error.response.data.error == 'invalid_token') {
                //     dispatch('getCrmAuthChecker', {'error' : 'invalid_token'});
                // }
            });
        }
    },
    mutations: {
        setOauthToken_from_server(state, data) {
            state.ucoCRM_oauth_token = data;
        },
        setOauthToken_testcrm_from_server(state, data) {
            state.ucoCRM_oauth_token = data;
        },
        setProjectFilCity(state, data) {
            // console.log(data, 'teststststststt')
            state.projectItemsFilterCity = data;
            state.salesItemBaner = false;
            setTimeout(() => {
                state.salesItemBaner = true;
            }, 50);
        },
        setBanerSystem(state, data) {
            state.banerSystem = data
        },
        // server mutations
        PageSetUp(state, setup) {
            state.pageSetup = setup
        },
        indexPage(state, data) {
            state.indexPage = data
        },
        aboutPageSet(state, data) {
            state.aboutPageArr = data
        },
        qualityPageSet(state, data) {
            state.qualityPage = data
        },
        projectsPageSet(state, data) {
            state.projectsPage = data
        },
        projectsBuiltOjects(state, data) {
            state.projectBuiltItems = data
        },
        actionPage(state, data) {
            state.actionPage = data
        },
        PrivacyPolicy(state, data) {
            state.privacyPolicyPage = data
        },
        newsPage(state, data) {
            state.newsPage = data
        },
        salesPage(state, data) {
            state.salesPage = data
        },
        flatsPage(state, data) {
            state.flatsPage = data
        },
        salesMapPage(state, data) {
            state.salesMapPage = data
        },
        HowToBy(state, data) {
            state.howToBy = data
        },
        HowToTake(state, data) {
            state.howToTake = data
        },
        enpfPage(state, data) {
            state.ENPFpage = data;
        },
        onlinePage(state, data) {
            state.onlinePage = data
        },
        FavoritePage(state, data) {
            state.favoritePage = data
        },
        ComparePageSet(state, data) {
            state.comparePage = data
        },
        HypothecPage(state, data) {
            state.hypothecPage = data
        },
        HypothecCalculatorPage(state, data) {
            state.hypothecCalculatorPage = data
        },
        bazisFinancePage(state, data) {
            state.bazisFinance = data
        },

        OnlineBoockingPage(state, data) {
            state.onlineBoockingPage = data
        },
        NewOwnersPage(state, data) {
            state.newOwnersPage = data
        },
        CommerceSalesPage(state, data) {
            state.commerceSalesPage = data
        },
        commerceSalesItems(state, data) {
            var dataARR = [];
            state.commerceSalesItems = [];
            for (var i = 0; i < data.length; i++) {
                dataARR.push(Object.assign(data[i].acf, {
                    id: data[i].id,
                }));
            }
            state.commerceSalesItems = dataARR;
        },
        SeismicSafetyPage(state, data) {
            state.seismicSafetyPage = data
        },
        sesmicSafetyNewsItems(state, data) {
            state.seismicSafetyNewsItems = data
        },
        sesmicSafetyVideoItems(state, data) {
            state.seismicSafetyVideoItems = data
        },
        AwardsPage(state, data) {
            state.awardsPage = data
        },
        AnswersPage(state, data) {
            state.answersPage = data
        },
        //contacts page
        contactsPage(state, data) {
            state.contactsPage = data
        },
        setContactsCardAnimation(state, data) {
            state.contactsCardAnimate = data
        },
        filterContactsMapCoords(state, data) {
            state.contactsMapCoords = data
        },
        setContactsPinCoords(state, data) {
            // console.log(data)
            state.pinCoords.lat = data.lat,
            state.pinCoords.lng = data.lng
        },
        //BAZIS CLUB
        bazisClubPage(state, data) {
            state.bazisClub = data
        },
        bazisClubItems(state, data) {
            state.bazisClubItems = [];
            var i;
            for (i = 0; i < data.length; i++) {
                state.bazisClubItems.push(data[i].acf);
            }
            // console.log(state.bazisClubItems, 'ITEMS');
        },
        bazisClubCategoryCounter(state, data) {
            state.bazisClubCategoryCounter = [];
            var i;
            var obj = {};
            for (i=0; i < data.length; i++) {
                obj[data[i].slug] = data[i].count;
                // this.counterArr.push({name: response.data[i].count});
            }
            state.bazisClubCategoryCounter = obj;
            // console.log(state.bazisClubCategoryCounter);
            // this.counterArr.push(obj);
        },
        //END BAZIS CLUB
        //SALES MUTATIONS
        projectItems(state, data) {
            var dataARR = [];
            state.projectItems = [];
            state.projectItemsDefault = [];
            state.projectItemsFilter = [];
            state.projectItemsMap = [];
            var i;
            // console.log(data);
            for (i = 0; i < data.length; i++) {
                // if (data[i].acf.project_name.slug != 'yassytower' && data[i].acf.project_name.slug != 'nurly-dala' && data[i].acf.project_name.slug != 'nurly-dala2') {
                //     dataARR.push(Object.assign(data[i].acf, {
                //         id: data[i].id,
                //     }));
                // }
                if (data[i].acf.project_show_on_sales == 'true') {
                    dataARR.push(Object.assign(data[i].acf, {
                        id: data[i].id,
                    }));
                }
            }
            state.projectItems = dataARR;
            state.projectItemsMap = dataARR;
            state.projectItemsDefault = dataARR;
            state.projectItemsFilter = dataARR;
            // state.projectItems = data;
        },
        FilterSalesProjectItems(state, data) {
            var dataArr = [];
            state.projectItemsDefaultFilterItems = [];
            for (var i = 0; i < data.length; i++) {
                dataArr.push(Object.assign(data[i].acf, {
                    id: data[i].id,
                }));
            }
            state.projectItemsDefaultFilterItems = dataArr;


             // for(var i=0; i < response.data.length; i++) {
            //     // console.log(response.data[i].acf.project_name.slug)
            //     if (response.data[i].acf.crm_code != null && response.data[i].acf.crm_code != '')  {
            //         if (response.data[i].acf.project_name.slug != 'nurly-dala') {
            //             dataResp.complexCodes.push(response.data[i].acf.crm_code); // Сбор параметров для запроса ЖК из СРМ
            //             // Для фильтра по жк (Сбор исходных кодов жк для СРМ)
            //             dataComplexes.push({
            //                 'code': response.data[i].acf.crm_code,
            //                 'name' : response.data[i].acf.project_name.name,
            //             });
            //         }
            //     }
            // }
        },
        filterProjectsItems(state, data) {
            state.projectItems = data;
        },
        filterProjectsItemsMap(state, data) {
            state.projectItemsMap = data;
        },
        filterFlatsCity(state, data) {
            state.filterFlatsCity = data;
        },
        cardAnimateSet(state, data) {
            state.cardAnimate = data
        },
        filterMapCoords(state, data) {
            state.mapCoords = data
        },
        filterMapItemsTheme(state, data) {
            state.MapItemsTheme = data
        },
        marMarkerPos(state, data) {
            state.MapMarkersPos = data
        },
        salesCardPageIDset(state, data) {
            state.salesCardPageID = data;
        },
        salesCardPage(state, data) {
            state.salesCardPage = data;
        },
        salesCardContent(state, data) {
            // state.salesCardContent = [];
            state.salesCardContent = data;
            // state.saleCardAnimate = true;
        },
        clearSalesLandCardContent(state, data) {
            state.salesCardContent = null;  
            // console.log('clear sales card land content');
        },
        salesCardContentFlats(state, data) { // sales land page flats
            var flatsArr = [];
            state.salesCardContentFlats = [];
            state.salesCardContentFlatsDefault = [];
            for (var i = 0; i < data.length; i++) {
                flatsArr.push(Object.assign(data[i].acf, {
                    id: data[i].id,
                    slug: data[i].slug,
                    type: data[i].acf.flats_card_name.split(",")[1].replace(' ','')
                }));
            }
            const shortByMinPrice = _(flatsArr)
                .groupBy('type')
                .map((group) => _.minBy(group, 'flats_card_price_min'))
                .value();

            // console.log(shortByMinPrice, 'RESULT');

            state.salesCardContentFlats = shortByMinPrice;
            state.salesCardContentFlatsDefault = shortByMinPrice;
            // console.log(state.salesCardContentFlats, 'FLATS STORE');
        },
        SalesFlatsCardAllClear(state, data) {
            state.salesCardContentFlats = [];
            state.salesCardContentFlats = data;
        },
        SalesFlatsAnimateCards(state, data) {
            state.salesFlatsLandCardAnimateCards = data;
        },
        salesLandModalDataArrr(state, data) {
            state.salesLandModalData = data;
            // console.log(state.salesLandModalData, 'TEST MODAL DATA')
        },
        salesCardContentFlats_filter(state, data) { // sales land page flats FILTER
            state.salesCardContentFlats = data;
        },
        resetSaleCardContent(state, data) {
            state.salesCardContent = data;
        },
        setAnimateSaleCard(state, data) {
            state.saleCardAnimate = data
        },
        //ACTIONS MUTATIONS
        actionsItems(state, data) {
            state.actionsItems = [];
            var i;
            for (i = 0; i < data.length; i++) {
                state.actionsItems.push(data[i].acf);
                state.actionsItemsDefault.push(data[i].acf);
                state.actionsItemsFilter.push(data[i].acf);
            }
            // state.projectItems = data;
        },
        filterActionsItems(state, data) {
            state.actionsItems = data;
        },
        ActionCardAnimateSet(state, data) {
            state.actionCardAnimate = data
        },
        //news MUTATIONS
        newsItems(state, data) {
            state.newsItems = [];
            var items = [];
            // console.log(data, 'news mutations');
            var i;
            for (i =0; i < data.length; i++) {
                items.push(data[i].acf)
            }
            for (i = 0; i < data.length; i++) {
                Object.assign(items[i], {
                    'id': data[i].id,
                    'slug': data[i].slug,
                    'date': data[i].date,
                });
            }
            for (i=0; i < items.length; i ++) {
                state.newsItems.push(items[i]);
                state.newsItemsDefault.push(items[i]);
                state.newsItemsFilter.push(items[i]);
            }
            // console.log(items, 'IETMS SUKA')
            // console.log(state.newsItems, 'ITEMS BUGAA')
            // state.projectItems = data;
        },
        newsPaginate(state, data) {
            // console.log(data);
            // state.newsItems = data;
        },
        filterNewsItems(state, data) {
            state.newsItems = data;
        },
        newsCardAnimateSet(state, data) {
            state.newsCardAnimate = data
        },
        newsCountOfPages(state, data) {
            state.newsPageCount = data
        },
        // NEWS MUTATIONS
        //Video mutations
        videoPage(state, data) {
            state.videoPage = data
        },
        videoItems(state, data) {
            // state.videoItems = [];
            var items = [];
            // console.log(data, 'news mutations');
            var i;
            for (i =0; i < data.length; i++) {
                items.push(data[i].acf)
            }
            for (i = 0; i < data.length; i++) {
                Object.assign(items[i], {
                    'id': data[i].id,
                    'slug': data[i].slug,
                    'date': data[i].date,
                });
            }
            for (i=0; i < items.length; i ++) {
                state.videoItems.push(items[i]);
                state.videoItemsDefault.push(items[i]);
                state.videoItemsFilter.push(items[i]);
            }
        },
        videoItemsSafety(state, data) {
            // state.videoItems = [];
            var items = [];
            // console.log(data, 'news mutations');
            var i;
            for (i =0; i < data.length; i++) {
                items.push(data[i].acf)
            }
            for (i = 0; i < data.length; i++) {
                Object.assign(items[i], {
                    'id': data[i].id,
                    'slug': data[i].slug,
                    'date': data[i].date,
                });
            }
            for (i=0; i < items.length; i ++) {
                state.videoItemsSafety.push(items[i]);
            }
        },
        videoPageCount(state, data) {
            state.videoPageCount = data
        },
        videoHidePaginate(state, data) {
            state.videoHidePaginBtn = data
        },
        filterVideoItems(state, data) {
            state.videoItems = data;
        },
        videoCardAnimateSet(state, data) {
            state.videoCardAnimate = data
        },
        // project mutations
        CurrentCity(state, data) {
            state.currentCity = data
        },
        CurrentCityArr(state, data) {
            state.currentCityArr = data
        },
        breadCrumbInt(state, data) {
            state.breadCrumbInit = data
        },
        setCustomCrumb(state, data) {
            state.customCrumbGlobalVar = data
        },
        setPageName(state, data) {
            state.pageName = null;
            state.pageName = data;
        },
        setFavoriteCount(state, data) {
            state.favoriteCount = data
        },
        HidePaginBtn(state, data) {
            state.hidePaginBtn = data
        },
        formsData(state, data) {
            state.forms = data
        },
        // MOBILE MUTATIONS
        setOpenPhonesCityMobile(state, data) {
            state.isOpenPhonesCityMobile = data
        },
        Open_Sendwich(state, data) {
            state.isOpenSendwich = data
        },
        Open_form_Consult(state, data) {
            state.isOpenFormConsult = data
        },
        Open_form_bazis_Club(state, data) {
            state.isOpenFormBazisClub = data
        },
        Open_form_SignUp_Project(state, data) {
            state.isOpenFormSignUpProject = data
        },
        openSalesModalAction(state, data) {
            state.isOpenSalesModal = data
        },
        openMapFlatsCrmCard(state, data) {
            state.isOpenMapFlatsCrmCard = data
        },
        openFormMailFlatsCRM(state, data) {
            state.isOpenFormMailFlatsCrm = data
        },
        openFormMailFlatsCRM_mobileSet(state, data) {
            state.isOpenFormMailFlatsCrmMobile = data
        },
        openSortFlatsTopBar(state, data) {
            state.isopenSortFlatsTopBar = data
        },
        Open_FormLandModal(state, data) {
            state.isOpenFormLandModal = data
        },
        set_view_bazis_Club_form(state, data) {
            state.formBazisClubView = data
        },
        getFormConsultData(state, data) {
            state.formConsultData = data
        },
        gridViewFlatsCardSet(state, data) {
            state.flatsLandGridView = data;
        },
        coockieBanerTopVisible(state, data) {
            state.coockieBanerTopVisible = data;
        },
        setMobileCheckerState(state, data) {
            state.isMobileChecker = data
        },
        removePageLoaderImg() {
            var loader = document.getElementById('loader');
            if (loader != undefined) {
                loader.classList.remove("InitLoader");
                setTimeout(()=>{
                    loader.remove();
                },1000);
            }
        },
        setSalesFilterParams(state, payload) {
            // salesFilterParams
            if (payload.type == 'cityActive') {
                state.salesFilterParams.cityActive = payload.data
            } else if (payload.type == 'saleStat') {
                state.salesFilterParams.saleStat = payload.data
            } else if (payload.type == 'initFilter') {
                state.salesFilterParams.initFilter = payload.data
            }
        },
        // МУТАЦИИ ДЛЯ ОБЪЕКТОВ СВЗЯЬ МЕЖДУ ПРОЕКТОМ И СРМ СИСТЕМОЙ
        crmItemsSet(state, data) {
            state.crmProjects = data;
        },
        filterCompelxes(state, data) {
            state.complexesItems = data
        },
        // МУТАЦИИ ДЛЯ ФИЛЬТРА ПО КВАРТИРАМ
        // МУТАЦИИ ПО КВАРТИРАМ СРМ
        FilterDataUpdate(state, payload) {
            // state.filterData = data
            if (payload.type == 'floor-filter') {
                state.filterData.floorRangeStart = payload.min;
                state.filterData.floorRangeEnd = payload.max;
            } else if (payload.type == 'size-filter') {
                state.filterData.areaFrom = payload.min;
                state.filterData.areaTo = payload.max;
            } else if (payload.type == 'price-filter') {
                state.filterData.meterPriceFrom = payload.min;
                state.filterData.meterPriceTo = payload.max;
            } else if (payload.type == 'pageNumber') {
                state.filterData.pageNumber = payload.number
            } else if (payload.type == 'complexCodesDefault') {
                state.filterData.complexCodes.push(payload.data)
            } else if (payload.type == 'complexCodes') {
                // console.log('asdasdasda');
                if (payload.param == 'reset') {
                    state.filterData.complexCodes = payload.data;
                } else if (payload.param == 'push') {
                    state.filterData.complexCodes.push(payload.data)
                } else if (payload.param == 'update') {
                    state.filterData.complexCodes = payload.data;
                    // console.log(state.filterData.complexCodes, 'asdasdasdasdas12313')
                } else if (payload.param == 'landmark') {
                    // console.log(payload.data, 'CRM CODE LAND STORE')
                    // console.log(state.filterData.complexCodes)
                }
            } else if (payload.type == 'roomQuantities') {
                state.filterData.roomQuantities = payload.data;
            }  else if (payload.type == 'cityCodes') {
                if (payload.param == 'reset') {
                    state.filterData.cityCodes = payload.data;
                }
            } 
            // filterData: { // переменные для хранения данных фильтрации
            //     cityCodes: [],
            //     complexCodes: [],
            //     roomQuantities: [],
            //     areaFrom: null,
            //     areaTo: null,
            //     floorRangeStart: null,
            //     floorRangeEnd: null,
            //     meterPriceFrom: null,
            //     meterPriceTo: null,
            //     linesOnPage: 30,
            //     pageNumber: 1,
            //     sortedByField: 'ROOM',
            //     sortedByDirection: 'ASCENDING',
            // },
        },
        flatsItemsArr(state, data) {
            // console.log(data, 'test')
            state.flatsItems = data;
            if (data.length == 0) {
                state.flatsEmptyMsg = true
                state.hidePaginBtn = true
            } else {
                state.flatsEmptyMsg = false
                state.hidePaginBtn = false
            }
        },
        flatsItemsArrPagination(state, data) {
            // console.log(data, 'PAGINATION MUTATION');
            for (var i = 0; i < data.length; i++) {
                state.flatsItems.push(data[i]);
            }
            if (data.length < 100) {
                state.hidePaginBtn = true
            }
            // console.log(state.flatsItems);
        },
        flatsPaginationCountersSet(state, data) {
            state.flatsPagination.allApartments = data.allApartments;
            state.flatsPagination.remainingApartments = data.remainingApartments;
            state.flatsPagination.remainingPages = data.remainingPages;
        },
        UpdatePaginPageNumber(state, data) {
            // console.log(data)
            state.pagin_PageNumber = data
        },
        SetVisibleFilterMobile(state, data) {
            state.visibleFilterMobile = data
        },
        TriggerResetFilterMove(state, data) {
            state.FilterResetTrigger = data
        },
        setVisibleCardImgWindow(state, data) {
            state.visibleCardImgWindow = data
            // console.log(state.visibleCardImgWindow)
        },
        setCardImgData(state, data) {
            state.cardImgWindowData = data
            // console.log(state.cardImgWindowData)
        },
        filterDynamicParamsUpdate(state, payload) {
            // console.log(state, payload.param, payload.data, 'DYNAMIC TEST')
            if (payload.param == 'city') {
                state.filterDynamicParams.cityActive = payload.data
                if (payload.data != 'all') {
                    state.filterDynamicParams.resetCity = false
                } else {
                    state.filterDynamicParams.resetCity = true;
                    state.filterDynamicParams.cityCodesRadioChecked = [];
                }
            } else if (payload.param == 'complex') {
                if (payload.data != 'all') {
                    state.filterDynamicParams.complexesCodeRadioChecked = [];
                    state.filterDynamicParams.descSelectComplexes = '';
                    state.filterDynamicParams.complexesCodeRadioChecked.push(payload.arr);
                } else {
                    state.filterDynamicParams.complexesCodeRadioChecked = [];
                    state.filterDynamicParams.selectedComplexes = [];
                }
            } else if (payload.param == 'complexReset') {
                state.filterDynamicParams.resetComplex = payload.data
            } else if (payload.param == 'descComplexes') {
                state.filterDynamicParams.descSelectComplexes = payload.data
            } else if (payload.param == 'setSelectedComplexes') {
                if (payload.type == 'push') {
                    state.filterDynamicParams.selectedComplexes.push(payload.data)
                } else {
                    // console.log(payload.data, 'asdasdasd')
                    state.filterDynamicParams.selectedComplexes = state.filterDynamicParams.selectedComplexes.filter(item => {
                        return item.code !== payload.data;
                    });
                    // this.selectedComplexes.filter(item => {
                    //     return item.code !== arr.code;
                    // });
                }
            } else if (payload.param == 'cityFilterDefault') {
                state.filterDynamicParams.cityFilterDefault = payload.data
            } else if (payload.param == 'projectFilterItems') {
                if (payload.type == 'itemsDefault') {
                    state.filterDynamicParams.projectsFilterDefault = payload.data;
                } else if (payload.type == 'itemsStart') {
                    state.filterDynamicParams.projectsFilterStart = payload.data
                } else if (payload.type == 'itemsComplexDefault') {
                    state.filterDynamicParams.projectsFilterComplexesDefault.push(payload.data)
                }
            } else if (payload.param == 'sortProjectItems') {
                    state.filterDynamicParams.projectsFilterDefault.sort(function(a, b) {
                        if (a.project_name.name > b.project_name.name) {
                            return 1; }
                        if (a.project_name.name < b.project_name.name) {
                            return -1; }
                        return 0;
                    });
            } else if (payload.param == 'shorting_rule') {
                if (window.GlobalLang == 'kz/') {
                    state.filterDynamicParams.shortingParamsDefault.rule = payload.data.name_kz
                } else if (window.GlobalLang == 'en/') {
                    state.filterDynamicParams.shortingParamsDefault.rule = payload.data.name_en
                } else {
                    state.filterDynamicParams.shortingParamsDefault.rule = payload.data.name
                }
            } else if (payload.param == 'shorting_param') {
                if (window.GlobalLang == 'kz/') {
                    state.filterDynamicParams.shortingParamsDefault.param = payload.data.name_kz
                } else if (window.GlobalLang == 'en/') {
                    state.filterDynamicParams.shortingParamsDefault.param = payload.data.name_en
                } else {
                    state.filterDynamicParams.shortingParamsDefault.param = payload.data.name
                }
            }
            // console.log(state.filterDynamicParams, 'MUTATIONS')
        },
        setFilterRangeMinMaxParams(state, data) { // Перебираем все дефолтные значения фильтров взятые из комплексов и выбираем из них минимальные и максимальные значения 
            // console.log(data, 'mimMAXXAXAXAXX')
            state.filterMinMaxParams = { // сброс всех значений
                init: false,
                price: {
                    min: [],
                    max: [],
                },
                size: {
                    min: [],
                    max: [],
                },
                floor: {
                    min: [],
                    max: [],
                },
            };

            for (var i=0; i < data.length; i++) { // обновляем новые данные значений
                // console.log(data[i], parseInt(data[i].filter_set_money.max));
                // Стоимость
                state.filterMinMaxParams.price.min.push(parseInt(data[i].filter_set_money.min));
                state.filterMinMaxParams.price.max.push(parseInt(data[i].filter_set_money.max));
                // Площадь
                state.filterMinMaxParams.size.min.push(parseFloat(data[i].filter_set_size.min));
                state.filterMinMaxParams.size.max.push(parseFloat(data[i].filter_set_size.max));
                 // Этаж
                state.filterMinMaxParams.floor.min.push(parseInt(data[i].filter_set_floor.min));
                state.filterMinMaxParams.floor.max.push(parseInt(data[i].filter_set_floor.max));
            }
            // Стоимость
            // console.log(state.filterMinMaxParams.price.max, 'PRICES MAX')
            state.filterMinMaxParams.price.min = Math.min(...state.filterMinMaxParams.price.min); 
            state.filterMinMaxParams.price.max = Math.max(...state.filterMinMaxParams.price.max); 
            // Площадь
            state.filterMinMaxParams.size.min = Math.min(...state.filterMinMaxParams.size.min); 
            state.filterMinMaxParams.size.max = Math.max(...state.filterMinMaxParams.size.max); 
            // Этаж
            state.filterMinMaxParams.floor.min = Math.min(...state.filterMinMaxParams.floor.min); 
            state.filterMinMaxParams.floor.max = Math.max(...state.filterMinMaxParams.floor.max);

            state.filterMinMaxParams.init = true;


            /// Добавляем определенные значения после вычеслний в переменную параметра запроса 
            state.filterData.areaFrom =  state.filterMinMaxParams.size.min;
            state.filterData.areaTo = state.filterMinMaxParams.size.max;
            state.filterData.floorRangeStart = state.filterMinMaxParams.floor.min;
            state.filterData.floorRangeEnd = state.filterMinMaxParams.floor.max;
            state.filterData.meterPriceFrom = state.filterMinMaxParams.price.min;
            state.filterData.meterPriceTo = state.filterMinMaxParams.price.max;
        },
    }
})